// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"90339b12","303":"d1b8e56a","775":"11564595","810":"a722163f","912":"ab1b625d","982":"323dc88d"}[chunkId] + ".chunk.css";
};